import { init, replayIntegration, browserTracingIntegration } from '@sentry/nuxt';

import { ClientSideNetworkError } from './utils/service';

interface Config {
  dsn: string;
  enable: boolean;
  release: string;
  environment: 'production' | 'development';
}

const setup = (config: Config) => {
  if (!config.enable) {
    return void console.info('Sentry is disabled');
  }

  if (!config.dsn) {
    return void console.error('Sentry DSN is not defined');
  }

  if (!config.release) {
    return void console.error('Sentry release version is not defined');
  }

  if (!config.environment) {
    return void console.error('Sentry current environment is not defined');
  }

  init({
    dsn: config.dsn,
    release: config.release,
    environment: config.environment,
    integrations: [
      browserTracingIntegration({}),
      replayIntegration({
        maskAllText: false,
        maxReplayDuration: 60 * 1000,
        networkRequestHeaders: ['X-Client-App', 'X-Client-Version'],
        networkDetailAllowUrls: ['/rest']
      })
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: ['/rest'],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: config.environment === 'production' ? 1 : 0,
    beforeSend(event, hint) {
      const error = hint?.originalException;

      return error instanceof ClientSideNetworkError
        ? null
        : event;
    }
  });
};

setup({
  dsn: 'https://cb5a84c74562493c11c6c18294f656b4@o4508931817013248.ingest.de.sentry.io/4509408256065616',
  enable: process.env.NODE_ENV === 'production',
  release: 'v' + __APP_VERSION__,
  environment: process.env.NODE_ENV as 'production' | 'development'
});
